import { UPLOAD_REQUEST, UPLOAD_ERROR, UPLOAD_SUCCESS } from '../actions/upload'
import apiCall from '@/utils/api'
import Vue from 'vue'
import { AUTH_LOGOUT } from '../actions/auth'
import axios from 'axios'

const state = { status: '', files: {} }

const getters = {
  getFiles: state => state.files,
}

const actions = {
  [UPLOAD_REQUEST]: ({commit, dispatch}, fileObject) => {
    console.log("Start upload request for file " + fileObject.file.file);
    commit(UPLOAD_REQUEST)

    //let formData = new FormData();
    var formData = new FormData();
    formData.append('file', fileObject.file.blob);

    axios.post( 'members/io/uploadFile',
      formData,
      {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
      }
    ).catch(resp => {
        console.log("file request error");
        commit(UPLOAD_ERROR)
        // if resp is unauthorized, logout, to
        // TODO: really logout?
        //dispatch(AUTH_LOGOUT)
      })
  },
}

const mutations = {
  [UPLOAD_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [UPLOAD_SUCCESS]: (state, files) => {
    state.status = 'success'
    //Vue.set(state, 'files', resp.data)
    state.files = files
  },
  [UPLOAD_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.files = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
